// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface StudentRealmItemPurchaseRequest
 */
export interface StudentRealmItemPurchaseRequest {
  /**
   *
   * @type {string}
   * @memberof StudentRealmItemPurchaseRequest
   */
  instanceId?: string
  /**
   *
   * @type {string}
   * @memberof StudentRealmItemPurchaseRequest
   */
  eventId?: string
  /**
   *
   * @type {string}
   * @memberof StudentRealmItemPurchaseRequest
   */
  itemId?: string
}

/**
 * Check if a given object implements the StudentRealmItemPurchaseRequest interface.
 */
export function instanceOfStudentRealmItemPurchaseRequest(
  value: object,
): boolean {
  let isInstance = true

  return isInstance
}

export function StudentRealmItemPurchaseRequestFromJSON(
  json: any,
): StudentRealmItemPurchaseRequest {
  return StudentRealmItemPurchaseRequestFromJSONTyped(json, false)
}

export function StudentRealmItemPurchaseRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentRealmItemPurchaseRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    instanceId: !exists(json, 'instanceId') ? undefined : json['instanceId'],
    eventId: !exists(json, 'eventId') ? undefined : json['eventId'],
    itemId: !exists(json, 'itemId') ? undefined : json['itemId'],
  }
}

export function StudentRealmItemPurchaseRequestToJSON(
  value?: StudentRealmItemPurchaseRequest | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    instanceId: value.instanceId,
    eventId: value.eventId,
    itemId: value.itemId,
  }
}
